<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='other_find_fire_binding'
      params>
      <div>
        <span class='left-table'>站点名称：</span>
        <el-input v-model='tableParams.station_name' placeholder='请输入站点名称' style='width: 200px;'></el-input>
        <span class='left-table'>
                  <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
                </span>
        <span class='left-table'>
                   <el-button type='success' icon='el-icon-circle-plus' @click='showAdd'>增加</el-button>
                </span>
      </div>
    </icare-table>
    <!-- 编辑 -->
    <el-dialog :title='editTip' :visible.sync='editVisible' width='50%' @closed='closeDialog'>

      <el-form label-width='120px' ref='form' :rules='rules' :model='form'>
        <el-form-item label='站点名称' v-if='!isEdit' prop='id'>
          <el-autocomplete style='width: 100%'
                           v-model='form.station_name'
                           :fetch-suggestions='querySearchAsync'
                           placeholder='请输入站点名称'
                           @select='handleSelectStation'
          ></el-autocomplete>
        </el-form-item>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button icon='el-icon-circle-close' @click='closeDialog'>取 消</el-button>
        <el-button type='primary' icon='el-icon-circle-plus-outline' @click='save'>确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'

export default {
  data() {

    return {
      loading: false,
      tableParams: {
        station_name: null
      },
      tableData: [],

      //编辑框信息
      editTip: '',
      editVisible: false,
      isEdit: false,
      titleConfig: [
        {
          field: 'username',
          title: '消防账号',
          visible: true
        },
        // {
        //   field: 'fire_terminal_id',
        //   title: '终端编号',
        //   visible: true
        // },
        {
          field: 'station_name',
          title: '站点名称',
          visible: true
        },
        // {
        //   field: 'address',
        //   title: '安装地址',
        //   visible: true
        // },
        {
          title: '操作',
          width: 60,
          align: 'right',
          option: true,
          children: [
            {
              title: '删除',
              icon: 'el-icon-delete',
              color: '#F56C6C',
              fuc: this.delete
            }
          ]
        }
      ],
      rules: {
        name: [
          { max: 20, message: '输入的文字过长，长度应在 20 个字符内', trigger: 'blur' }
        ]
      },
      form: {
        id: 0
      },
      formLabelWidth: '100px'
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {
    this.tableParams.fire_user_id = this.$route.query.fire_user_id
    this.$refs.table.refresh()
  },
  methods: {
    //弹出编辑(新增)对话框
    showAdd() {
      this.isEdit = false
      this.editVisible = true
      this.editTip = '新增信息'
      this.form = Object.assign({})
    },
    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.form = {}
    },
    //模糊搜索
    find() {
      this.tableParams.station_name = this.tableParams.station_name
      this.$refs.table.refresh()
    },
    //删除某条记录
    delete(row) {
      this.$confirm('是否要删除：' + row.name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'other_remove_fire_binding',
          params: str
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(() => {
      })
    },

    save() {

      let _this = this
      this.$refs.form.validate(valid => {
        if (valid) {
          _this.form.fire_user_id = this.tableParams.fire_user_id
          gateway({
            func: 'other_add_fire_binding',
            params: JSON.stringify(_this.form)
          }).then(res => {
            if (res.code === 0 || res.code == 10004) {
              this.$message.success('新增成功')
              this.closeDialog()
              this.$refs.table.refresh()
            } else {
              this.$message.warning(res.msg)
            }
          })

        } else {
          return false
        }
      })
    },

    /** 远程搜索客户操作 */
    querySearchAsync(queryString, cb) {

      var name = null
      this.form.station_id = null

      if (queryString !== '') {
          name = queryString
      }

      let str = JSON.stringify({
        page_no: 1,
        page_size: 30,
        name: name
      })

      gateway({
        func: 'get_station_list',
        params: str
      }).then(res => {
        this.list = []
        for (var i = 0; i < res.result.length; i++) {
          var item = {
            value: res.result[i].name,
            id: res.result[i].id
          }
          this.list.push(item)
        }
        cb(this.list)
      })
    },
    /** 点击远程搜索返回站点的选择操作 */
    handleSelectStation(item) {
      this.form.station_id = item.id
      this.form.station_name = item.value
    }

  }
}
</script>
<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}

.amap-demo {
  height: 400px;
}
</style>
